import backgroundTint from "components/show-win-lines/background-tint";
import Components from "slotworks/components/components";
import SymbolWinResult from "slotworks/model/gameplay/records/results/symbol-win-result";
import LoopWins from "slotworks/state-machine/standard/states/loop-wins";

import {PlaySymbolSoundCommand} from "slotworks/commands/symbols/play-symbol-sound-command";
import DimSymbolsCommand, {DimType} from "slotworks/commands/symbols/dim-symbols-command";
import {reject} from "slotworks/utils/collection-utils";
import gameState from "slotworks/model/game-state";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import Parallel from "slotworks/utils/contracts/parallel";
import SymbolComponent from "slotworks/components/matrix/symbol/symbol-component";
import sgWildsComponent from "components/wilds/sg-wilds-component";
import Contract from "slotworks/utils/contracts/contract";
import sgSandAnimation from "components/sg-sand-animation";

export class SGLoopWins extends LoopWins {

    public onSkip(): void {
        backgroundTint.hide();
        sgWildsComponent.skip();
        super.onSkip();
    }

    protected showWin(win: SymbolWinResult): Contract<void> {
        sgSandAnimation.stopSandAnimation();
        const winningSymbols = Components.matrix.getSymbolsFromPositions(win.positions);

        const nonWinningSymbols = Components.matrix.getAllSymbols().filter((value) => {
            return winningSymbols.indexOf(value) === -1;
        });
        nonWinningSymbols.forEach((symbol) => symbol.static());
        backgroundTint.updateDepth([win]);
        backgroundTint.show();

        const gameplay = gameState.getCurrentGame();
        const record = gameplay.getCurrentRecord() as SpinRecord;

        const currentCycle = this.recordCycleCount.get(record);
           
        PlaySymbolSoundCommand(win.symbolType, win.matches.toString(), currentCycle.toString());        


        const remainingSymbols = reject(Components.matrix.getBaseGridSymbols(), winningSymbols);

        const hiddenSymbols = Components.matrix.getHiddenSymbols();
        DimSymbolsCommand(remainingSymbols.concat(hiddenSymbols), DimType.Cycle).execute();

        if (!winningSymbols.length) {
            return Contract.getTimeoutContract(1000);
        }

        return this.getWinningSymbolsCommand(winningSymbols, currentCycle > 0);
    }


    private getWinningSymbolsCommand(symbols: SymbolComponent[], cycling: boolean = false): Contract<void> {
        const winningSymbolWinMethods: Array<() => Contract<void>> = [];

        let nonWildSymbols: SymbolComponent[] = symbols.filter(item => item.symbolId.indexOf("expanded") === -1);

        for (const symbol of nonWildSymbols) {
            winningSymbolWinMethods.push(() => cycling ? symbol.cycle() : symbol.win());
        }

        let wildSymbols: SymbolComponent[] = reject(symbols, nonWildSymbols);
        if (wildSymbols.length > 0) {
            winningSymbolWinMethods.push(() => sgWildsComponent.playWinAnimation(this.getWildWinFlags(wildSymbols)));
        }

        return new Parallel(winningSymbolWinMethods);
    }

    private getWildWinFlags(symbols: SymbolComponent[]) {
        let flags = [false, false, false];
        symbols.forEach(symbol => {
            flags[symbol.gridPosition.x - 2] = true;
        });
        return flags;
    }

}
